var _defs, _line, _path, _circle, _line2, _path2, _circle2, _line3, _circle3, _line4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvMoneyBackGuarantee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.a{stroke:#ff5a00;stroke-linecap:round;stroke-linejoin:round;}.b{stroke:#81949c;stroke-miterlimit:10;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 62.23,
    y1: 60.496,
    x2: 59.795,
    y2: 66.061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.52,65.618A8.686,8.686,0,1,1,66.4,70.607"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 68.767,
    cy: 13.976,
    r: 8.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 72.212,
    y1: 12.024,
    x2: 65.061,
    y2: 15.856
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.47,72.179c6.418-3.423,19.072-10.5,25.489-13.918a5.11,5.11,0,0,1,6.761,7.217,2.685,2.685,0,0,1-.844.809L58.587,91.638A17.877,17.877,0,0,1,49.6,94.205a17.544,17.544,0,0,1-6.418-1.284,156.853,156.853,0,0,1-17.907-8.263l-.027-.014a5.662,5.662,0,0,0-4.24-.3c-2.346.7-6.951,2.051-7.876,2.239a3.97,3.97,0,0,1-2.048-.056A5.264,5.264,0,0,1,7.8,83.4L.827,65.963c-.773-2.5-.284-3.813,2.63-5.4,2.394-1.6,8.073-5.4,15.34-6.154a36.809,36.809,0,0,1,6.418,0,34.268,34.268,0,0,1,6.417,1.284,16.144,16.144,0,0,1,6.513,3.111A47.72,47.72,0,0,0,41.9,62.112a17.285,17.285,0,0,0,5.134,2.568,29.744,29.744,0,0,0,6.418,1.283c1.921.259,4.756.651,8.318,1.184a4.968,4.968,0,0,1,1.642.532,5.5,5.5,0,0,1,1.624,8.68A3.657,3.657,0,0,1,62.475,77.6a86.436,86.436,0,0,1-11.589-.084,86.274,86.274,0,0,1-15.4-2.568"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 45.914,
    cy: 41.771,
    r: 8.18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 47.069,
    y1: 37.983,
    x2: 44.522,
    y2: 45.687
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 76.378,
    cy: 40.2,
    r: 8.18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 80.165,
    y1: 41.355,
    x2: 72.463,
    y2: 38.808
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: -847.864,
    y: -414.744,
    width: 1260,
    height: 1962
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvMoneyBackGuarantee);
export default __webpack_public_path__ + "static/media/sv-money-back-guarantee.827e2e563ff22083b70309a16612319c.svg";
export { ForwardRef as ReactComponent };